import client from '../../client/personAttrClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    public async selectPageData(params: any) {
        const result = await client.selectPageData(params);
        if (result) {
            return result;
        }
    }
    public async updateAnswer(params: any) {
        const result = await client.updateAnswer(params);
        if (result) {
            return result;
        }
    }
    // 删除当前ip的所有问题
    public async deleteCurIp(params: any) {
        const result = await client.deleteCurIp(params);
        if (result) {
            return result;
        }
    }
    // 返回猜的人物
    public async selectRealPerson(params: any) {
        const result = await client.selectRealPerson(params);
        if (result) {
            return result;
        }
    }
    
}
